export default __webpack_public_path__ + "static/media/visual4.e3938350.png";